export const TODAY_DATE = new Date()
export const FIRST_MONTH_DAY = new Date(TODAY_DATE.getFullYear(), TODAY_DATE.getMonth(), 1)

export const END_DATE_MONTH = new Date(
  Date.UTC(TODAY_DATE.getUTCFullYear(), TODAY_DATE.getUTCMonth() + 1, 0, 23, 59, 59, 999)
)

export const ERROR_MESSAGE_SCHEMAS = {
  required_error: 'Campo obrigatório',
  invalid_type_error: 'Campo obrigatório',
  invalid_date_type_error: 'Data inválida'
}

export const SELECT_MOTIVOS_FLEX = [
  'Contratação Acima do Limite do Segmento',
  'Contratação Acima do Limite Global',
  'Contratação Acima do Limite Global e do Segmento'
]
